import { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';

import { useHandleOAuthResult } from '@/modules/auth/components/LoginButton/hooks/useHandleOAuthResult';
import { composeSignInUrl } from '@/modules/auth/services/oauth/composeSignInUrl';
import { Button } from '@/modules/ui';

import { AlertCard } from '../AlertCard';

export const UnauthenticatedSecretAlert = () => {
    const signInUrl = useMemo(() => composeSignInUrl(), []);
    const oauthResult = useHandleOAuthResult();

    return (
        <AlertCard
            title={{ id: 'sharedSecret.alert.unauthenticatedNotFound.title' }}
            description={{ id: 'sharedSecret.alert.unauthenticatedNotFound.description' }}
            footer={
                <Button type='default' href={signInUrl} target='_self' rel='noopener noreferrer' loading={oauthResult.isLoading}>
                    <FormattedMessage id='sharedSecret.alert.unauthenticatedNotFound.button' />
                </Button>
            }
        />
    );
};
